import { Close } from "@mui/icons-material"
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material"
import MaterialBox from "../../../components/MaterialBox"
import MaterialButton from "../../../components/MaterialButton"
import MaterialTypography from "../../../components/MaterialTypography"
import BASEURL from "../../Utils/Baseurl"
import { useLoading } from "../../../context/loading"
import Swal from "sweetalert2"
import axios from "axios"
import { updatePolicyStatus } from "./Queries"

const PolicyAcknowledgementDialog = ({open, setOpen, selectedPolicyId, selectedPolicyTitle, subTabValue, fetchUserListPolicy, fetchHrListPolicy}) => {

    const { setCirleLoading } = useLoading();

    const handleUpdateStatus = async (status) => {
        setCirleLoading(true);
        try {
            const response = await axios.post(
            BASEURL,
            {
                query: updatePolicyStatus,
                variables: {
                input: {
                    id: selectedPolicyId,
                    status: status,
                },
                },
            },
            {
                headers: {
                "Content-Type": "application/json",
                },
            }
            );
            
            const mutationResponse = response?.data?.data?.updatePolicyStatus;
            const success = mutationResponse?.success;
            const message = mutationResponse?.message;

            // SweetAlert feedback
            Swal.fire({
                position: "center",
                icon: success ? "success" : "error",
                title: message,
                showConfirmButton: false,
                timer: 2000,
            });

            // refresh table
            if (success) {
                if (subTabValue === "userList") {
                    fetchUserListPolicy();
                } else if (subTabValue === "hrList") {
                    fetchHrListPolicy();
                }
                // close dialog after success
                setTimeout(() => {
                    setOpen(false);
                }, 500);
            }
        } catch (error) {
            console.error("Error Updating Policy Status:", error);

            Swal.fire({
                position: "center",
                icon: "error",
                title: "Unable to update policy status",
                showConfirmButton: false,
                timer: 2000,
            });
        } finally {
            setCirleLoading(false);
        }
    };

  return (
    <Dialog open={open}>
        <DialogTitle>
            Acknowledge / Ignore Policy
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
                >
                <Close />
            </IconButton>
        </DialogTitle>
        <DialogContent>
            <MaterialTypography variant="h6" fontWeight="medium" color="black">
                <b>Policy:</b> {selectedPolicyTitle ? selectedPolicyTitle : "Not Found"}
            </MaterialTypography>
            <MaterialBox
                sx={{
                display: "flex",
                justifyContent: "center",
                gap: 2,
                pt: 1,
                minWidth: 300
                }}
            >                
                <MaterialButton
                variant="contained"
                color="error"
                onClick={() => handleUpdateStatus("Ignored")}
                >
                Ignore
                </MaterialButton>

                <MaterialButton
                variant="contained"
                color="success"
                onClick={() => handleUpdateStatus("Acknowledged")}
                >
                Acknowledge
                </MaterialButton>
            </MaterialBox>
        </DialogContent>
    </Dialog>
  )
}

export default PolicyAcknowledgementDialog